import { useEffect, useState } from "react";
import axios from "axios";
import { BellOff, BellRing } from "lucide-react";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });
api.interceptors.request.use((c) => { const t = localStorage.getItem("feemitra_token"); if (t) c.headers.Authorization = `Bearer ${t}`; return c; });
const errOf = (e, d) => { const x = e.response?.data?.detail; return typeof x === "string" ? x : d; };

const supported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const toKey = (b64) => { const p = "=".repeat((4 - (b64.length % 4)) % 4); const raw = atob((b64 + p).replace(/-/g, "+").replace(/_/g, "/")); return Uint8Array.from([...raw].map(c => c.charCodeAt(0))); };

export async function dropPushOnLogout() {
  try {
    if (!supported()) return;
    const reg = await navigator.serviceWorker.getRegistration(); const s = reg && await reg.pushManager.getSubscription();
    if (s) { await api.post("/push/unsubscribe", { endpoint: s.endpoint, keys: {} }).catch(() => {}); await s.unsubscribe(); }
  } catch { /* ignore */ }
}

export function FeeAlertsCard({ notify }) {
  const [state, setState] = useState("loading");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!supported()) { setState(isIOS() && !standalone() ? "ios" : "unsupported"); return; }
    if (Notification.permission === "denied") { setState("denied"); return; }
    navigator.serviceWorker.ready.then(r => r.pushManager.getSubscription()).then(s => {
      if (!s) return setState("off");
      const j = s.toJSON();
      api.post("/push/subscribe", { endpoint: j.endpoint, keys: j.keys }).then(() => setState("on")).catch(() => setState("off"));
    }).catch(() => setState("off"));
  }, []);
  if (state === "loading" || state === "unsupported") return null;
  const enable = async () => {
    setBusy(true);
    try {
      if (await Notification.requestPermission() !== "granted") { setState("denied"); return; }
      const reg = await navigator.serviceWorker.ready;
      const { data } = await api.get("/push/public-key");
      const sub = (await reg.pushManager.getSubscription()) || await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.public_key) });
      const j = sub.toJSON();
      await api.post("/push/subscribe", { endpoint: j.endpoint, keys: j.keys });
      setState("on"); notify("Fee alerts chalu ho gaye");
    } catch (e) { notify(errOf(e, "Alerts chalu nahi ho paaye — dobara koshish karein"), true); } finally { setBusy(false); }
  };
  const disable = async () => {
    setBusy(true);
    try { const reg = await navigator.serviceWorker.ready; const s = await reg.pushManager.getSubscription(); if (s) { await api.post("/push/unsubscribe", { endpoint: s.endpoint, keys: {} }).catch(() => {}); await s.unsubscribe(); } setState("off"); notify("Fee alerts band kar diye"); }
    finally { setBusy(false); }
  };
  const test = async () => { setBusy(true); try { await api.post("/push/test"); notify("Test alert bheja — phone ki notification dekhein"); } catch (e) { notify(errOf(e, "Test alert nahi gaya"), true); } finally { setBusy(false); } };
  const text = { ios: "iPhone par pehle FeeMitra ko Home Screen par add karein (Share → Add to Home Screen), phir wahan se khol kar alerts chalu karein.",
    denied: "Is phone par notifications band hain. Browser/phone ki Settings → Notifications mein FeeMitra ko Allow karein.",
    off: "Nayi fee aane ya fee due hone par phone par turant notification paayein.", on: "Chalu hai — nayi fee ya due date par is phone par notification aayega." }[state];
  return <div className="install-banner fee-alerts-card" data-testid="fee-alerts-card">
    <span className="fee-alerts-icon">{state === "on" ? <BellRing size={20} /> : <BellOff size={20} />}</span>
    <div className="install-text"><b>Fee alerts phone par</b><small data-testid="fee-alerts-status">{text}</small></div>
    {state === "off" && <button className="primary-btn small" disabled={busy} onClick={enable} data-testid="fee-alerts-enable">Chalu karein</button>}
    {state === "on" && <div className="wa-row-actions" style={{ marginTop: 0 }}>
      <button className="secondary-btn small" disabled={busy} onClick={test} data-testid="fee-alerts-test">Test</button>
      <button className="secondary-btn small" disabled={busy} onClick={disable} data-testid="fee-alerts-disable">Band karein</button></div>}
  </div>;
}
